/**
 * HFD DK63Star V2 磁轴的 VID+PID 列表（当前仅有线；厂商 HID manufacturerName: hfdic）。
 * 虚拟键盘矩阵对齐星闪 DK63 V2（keyboardType=63，单灯）；协议走华奋达磁轴（magneticAxis）。
 */
export const HFD_DK63STAR_VENDOR_PRODUCT: ReadonlyArray<{
  vendorId: number;
  productId: number;
  identifier: string;
}> = [
  { vendorId: 0x0c45, productId: 0x80f8, identifier: "3141:33016:DK63Star" }, // 有线
];

/** SDK / 配置表 product 版本信息 */
export const HFD_DK63STAR_PRODUCT = 111;

export type HfdDk63StarEquipmentLike = {
  vendorId?: number;
  productId?: number;
  keyboardType?: string;
  displayname?: string;
  productName?: string;
  solutionRovider?: string;
  identifier?: string;
  product?: unknown;
  workMode?: unknown;
};

function dk63StarNameBlob(eq: HfdDk63StarEquipmentLike): string {
  return `${eq.displayname ?? ""} ${eq.productName ?? ""} ${eq.keyboardType ?? ""}`;
}

/** 是否为 HFD DK63Star 设备（有线） */
export function isHuafendaDk63StarDevice(
  eq: HfdDk63StarEquipmentLike | null | undefined
): boolean {
  if (!eq) return false;

  const pid = Number(eq.productId);
  if (pid === 0x80f8) return true;

  const nameBlob = dk63StarNameBlob(eq);
  if (/\bdk63\s*star\b/i.test(nameBlob) || /\bdk63star\b/i.test(nameBlob)) {
    const provider = String(eq.solutionRovider ?? "")
      .trim()
      .toLowerCase();
    // 星闪亦有 displayname「DK63 Star」；无 provider 时仅信 VID/PID / identifier
    if (provider === "huafenda") return true;
  }

  const id = String(eq.identifier ?? "").trim();
  if (id.includes("33016") || /dk63star/i.test(id)) return true;

  const product = Number(eq.product);
  if (product === HFD_DK63STAR_PRODUCT && pid === 0x80f8) return true;

  const vid = Number(eq.vendorId);
  if (!Number.isFinite(vid) || !id) return false;
  return HFD_DK63STAR_VENDOR_PRODUCT.some(
    (p) =>
      p.vendorId === vid &&
      (p.identifier === id || id.startsWith(`${p.identifier}:`))
  );
}

/** 是否为 HFD DK63Star（展示名 / 配置表匹配） */
export function isHuafendaDk63StarEquipment(
  eq: HfdDk63StarEquipmentLike | null | undefined
): boolean {
  if (!eq || typeof eq !== "object") return false;
  const provider = String(eq.solutionRovider ?? "")
    .trim()
    .toLowerCase();
  if (provider && provider !== "huafenda") return false;
  return isHuafendaDk63StarDevice(eq);
}

/** DK63Star 有线（USB 0x80f8） */
export function isHuafendaDk63StarWired(
  eq: HfdDk63StarEquipmentLike | null | undefined
): boolean {
  return isHuafendaDk63StarDevice(eq) && Number(eq?.productId) === 0x80f8;
}
